import { isNil, merge } from 'lodash';
import { CSSProperties, useMemo } from 'react';
import { CssVars, ViewProps } from './props';

export function useStyles({
  gap,
  margin,
  marginTop,
  marginLeft,
  marginRight,
  marginBottom,
  marginVertical,
  marginHorizontal,
  padding,
  paddingTop,
  paddingLeft,
  paddingRight,
  paddingBottom,
  paddingVertical,
  paddingHorizontal,
  flex,
  vars,
  style,
}: ViewProps): CSSProperties {
  return useMemo(() => {
    // if true, flex = 1; if number, flex = number; if false, flex = undefined
    const flexStyle = flex ? { flex: Number(flex) } : undefined;
    const allVars = {
      gap,
      margin,
      marginTop,
      marginLeft,
      marginRight,
      marginBottom,
      marginVertical,
      marginHorizontal,
      padding,
      paddingTop,
      paddingLeft,
      paddingRight,
      paddingBottom,
      paddingVertical,
      paddingHorizontal,
      ...vars,
    };
    return merge(createStyleVars(allVars), flexStyle, style);
  }, [
    gap,
    margin,
    marginTop,
    marginLeft,
    marginRight,
    marginBottom,
    marginVertical,
    marginHorizontal,
    padding,
    paddingTop,
    paddingLeft,
    paddingRight,
    paddingBottom,
    paddingVertical,
    paddingHorizontal,
    flex,
    vars,
    style,
  ]);
}

const shorthandGridVars = [
  'margin',
  'marginVertical',
  'marginHorizontal',
  'padding',
  'paddingVertical',
  'paddingHorizontal',
];

function createStyleVars(vars: CssVars = {}) {
  const paddingVars = {
    marginTop: vars.marginTop ?? vars.marginVertical ?? vars.margin,
    marginBottom: vars.marginBottom ?? vars.marginVertical ?? vars.margin,
    marginLeft: vars.marginLeft ?? vars.marginHorizontal ?? vars.margin,
    marginRight: vars.marginRight ?? vars.marginHorizontal ?? vars.margin,
    paddingTop: vars.paddingTop ?? vars.paddingVertical ?? vars.padding,
    paddingBottom: vars.paddingBottom ?? vars.paddingVertical ?? vars.padding,
    paddingLeft: vars.paddingLeft ?? vars.paddingHorizontal ?? vars.padding,
    paddingRight: vars.paddingRight ?? vars.paddingHorizontal ?? vars.padding,
  };
  return Object.entries({ ...vars, ...paddingVars }).reduce((memo: CssVars, [key, value]) => {
    if (shorthandGridVars.includes(key)) {
      return memo;
    } else if (isNil(value)) {
      return memo;
    } else {
      return { ...memo, [`--${key}`]: value };
    }
  }, {});
}
